import {mutationTypes} from '@/core/constants'
import SockJS from 'sockjs-client'
import Stomp from 'webstomp-client'
import store from '@/core/store'

export default class WebsocketHelper {
    async conectar (user, token){
        const sockjs = new SockJS('/compra-direta/api/public/ws-compra-direta')

        // const sockjs = new SockJS('/compra-direta/api/public/ws-compra-direta', null, {
        //     transportOptions: {
        //         'xhr-streaming': {
        //             headers: {
        //                 'Authorization': token
        //             }
        //         }
        //     }
        // })

        const stomp = Stomp.over(sockjs, {debug: false})

        const headers = {
            tipo: user.domainType,
            dominioId: user.domainId,
            usuarioId: user.id,
            'Authorization': token
        }

        stomp.debug = (event) => {
            if(event && (event.includes('CONNECTED') || event.includes('SUBSCRIBE')))
                console.log(event)
        }
        stomp.connect(headers, () => this.subscribeForNotification(stomp, user),
            () =>  {
                store.commit(mutationTypes.SET_WEBSOCKET_SERVICE, null)
            })
    }

    subscribeForNotification(stomp, user){
        let notificacaoUrl = `/topic/NOTIFICACAO:${user.domainType}:${user.domainId}`
        let notificacaoMensagemUrl = `/topic/NOTIFICACAO_CHAT:${user.domainType}:${user.domainId}`

        if(user.domainType === 'ESTRUTURA_ORGANIZACIONAL'){
            notificacaoUrl = `/topic/NOTIFICACAO:ESTRUTURA_ORGANIZACIONAL:${user.id}`
            notificacaoMensagemUrl = `/topic/NOTIFICACAO_CHAT:ESTRUTURA_ORGANIZACIONAL:${user.id}`
        }

        stomp.subscribe(notificacaoUrl, (message) => {
            const data = JSON.parse(message.body)
            store.commit(mutationTypes.LOKI.SET_NOTIFICACOES_NAO_LIDAS, (data.totalNaoLidas) ? data.totalNaoLidas : 0)
        })

        stomp.subscribe(notificacaoMensagemUrl, (message) => {
            const data = JSON.parse(message.body)
            store.commit(mutationTypes.SET_CHAT_NOTIFICACOES_NAO_LIDAS, (data.totalNaoLidas) ? data.totalNaoLidas : 0)
        })

        store.commit(mutationTypes.SET_WEBSOCKET_SERVICE, stomp)
    }
}